import { layout } from 'thewest/App.routing'

export const yourMoneySegment = layout.component({
    type: 'uniform',
    props: {
        sectionHeader: {
            heading: 'Your Money',
            headingUrl: '/business/your-money',
            section: 'business',
        },
        verticalSpacing: 'xl',
        section: 'default',
        cardOrientation: { type: 'Landscape-Portrait' },
        cardLayout: [
            ['teaserWithBackground'],
            ['commonWithBackground', 'titleOnly'],
            ['commonWithBackground', 'titleOnly'],
            ['teaserWithBackground'],
        ],
        dataDefinitionArgs: {
            type: 'curation',
            name: 'your-money',
            offset: 0,
            pageSize: 6,
        },
    },
})
